import {Component, OnInit, Injector} from '@angular/core';
import {AppComponentBase} from '../../../services/AppComponentBase';
import {technicalIndicatorDisable} from '../../achart/achart.technicalIndicators';
import {ScannerPrimarySearchList, ScannerChartingStudy, ScannerSide} from '../interfaces/scanner.enums';
import {HistoryItemPeriod} from '../../../interfaces/historyItem';
import {showScannerTrialReminderModal} from '../modals/ScannerTrialReminder/show-ScannerTrialReminder-modal';

@Component({
    selector: 'app-fullscreen-scanner',
    template: require('./fullscreen-scanner.component.html'),
    styles: [require('./fullscreen-scanner.component.scss')]
})
export class FullscreenScannerComponent extends AppComponentBase implements OnInit {

    constructor(injector: Injector) {

        super(injector);
        this.workspace.globaGridMode.fullScreenScanerAction.subscribe(v => {
            if(v == "backFromNarrow") {
                this.isNarrowScanMode = false;
            }
        })
        this.workspace.globaGridMode.scanReset.subscribe(v => {
            this.newScanProcess()
        })
    }


    ngOnInit() {
    }

    public closeScannerWindow() {

        if(!this.isNarrowScanMode) {
            this.workspace.showScannerPage = false
        }
        else {
            this.isNarrowScanMode = false;
            this.workspace.globaGridMode.fullScreenScanerAction.next("backFromNarrow");
        }
    }


    public newScanProcess() {
        //  this.workspace.canShowScannerSearchForm 
        this.workspace.initLoadScan = null;
        this.workspace.selectedPrimaryScanner = ScannerPrimarySearchList.SCANNER_NA;
        this.workspace.scanFinished = true;
        this.workspace.scanInProgress = false;

        this.workspace.scannerSearch_Narrow_chartingstudy = ScannerChartingStudy.SCANNER_RSI;
        this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_BUY;
        this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
        this.workspace.scannerSearch_chartingstudy = ScannerChartingStudy.SCANNER_RSI;

        this.workspace.showScanButton = false;

        this.workspace.scanResultList = [];
        this.workspace.scannerSearch_period = HistoryItemPeriod.Min1;


        this.workspace.scannerCurrentRule = [];
        this.workspace.canShowScannerSearchForm = true;
        this.workspace.showScanResults = false;
        this.workspace.scanFinished = false;
        this.workspace.allowScanProcess = false;

        this.workspace.scannerSearch_Narrow_period = HistoryItemPeriod.Min1;


        this.workspace.scannerCurrentRule_Narrow = [];
        this.workspace.narrowscanFinished = false;
        this.workspace.narrowScanComponent = ScannerPrimarySearchList.SCANNER_NA;
        this.workspace.selectedSavedScan = "";
        this.workspace.showBackToResults = false;

        this.workspace.globaGridMode.fullScreenScanerAction.next("newScan");
        this.isNarrowScanMode = false;
    }




    public showNarrowScan() {
        console.log("SHOWNARROWSCAN");
        this.isNarrowScanMode = true;


        if(this.workspace.selectedSavedScan != "") {
            let selected = this.workspace.savedScansOnePool.find(v => v.key == this.workspace.selectedSavedScan);
            if(selected) {
                this.workspace.globaGridMode.loadScannerRule.next(selected);
            }

        }
        else {
            this.workspace.selectedPrimaryScanner_Narrow = ScannerPrimarySearchList.SCANNER_NA;
            this.workspace.narrowScanComponent = ScannerPrimarySearchList.SCANNER_NA;
            // this.workspace.selectedSavedScan = "";
        }

    }

    private _isNarrowScanMode: boolean = false;
    public get isNarrowScanMode(): boolean {
        return this.workspace.isNarrowScanMode;
    }
    public set isNarrowScanMode(value: boolean) {
        this.workspace.isNarrowScanMode = value;
    }

    public get allowAccess(): boolean {
        return this.workspace.allowScannerAccess;
    }

    public get trialExpired(): boolean {
        return this.workspace.isTrialExpired;
    }

    public get daysToTrialEnd() {
        return this.workspace.trialDaysToEnd;
    }

    public get hasSomeProduct(): boolean {
        return this.workspace.hasSomeProduct;
    }


    public buyNow()
    {
        showScannerTrialReminderModal(this.modalService, this.workspace.mobileMode);
    }
}
